import { useRecoilState, useRecoilValue } from "recoil";
import { deviceListState, userListState } from "../atom/atom";
import PushNotificationForm from "../components/PushNotificationForm";
import { useEffect, useMemo, useState } from "react";
import {
  fetchAndSetData,
  fetchDeviceList,
  fetchUserList,
} from "../api/fetch.api";
import CopyText from "../components/CopyText";
import { Device, SongRequest } from "../types/type";
import PushNotificationFormMany from "../components/PushNotificationFormMany";

type IMergedUser = {
  userId: string;
  userName: string;
  email: string;
  fcmToken: string;
  hashedDeviceId: string;
  songRequestList: SongRequest[];
};

function UserDevicePage() {
  const [userList, setUserList] = useRecoilState(userListState);
  const [deviceList, setDeviceList] = useRecoilState(deviceListState);
  const [expandedRowIndex, setExpandedRowIndex] = useState<number | null>(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [hashedDeviceIdList, setHashedDeviceIdList] = useState<string[]>([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState<Device[]>([]);

  const itemsPerPage = 50; // 페이지당 보여줄 데이터 수

  useEffect(() => {
    if (deviceList.length === 0)
      fetchAndSetData(fetchDeviceList, setDeviceList);
    if (userList.length === 0) fetchAndSetData(fetchUserList, setUserList);
  }, [deviceList, userList]);

  const mergedUserData: IMergedUser[] = useMemo(() => {
    return userList.map((user) => {
      const matchingDevice = deviceList.find(
        (device) =>
          (device.email === user.email && device.userName === user.userName) ||
          device.userId === user.userId
      );
      return {
        userId: user.userId,
        userName: user.userName,
        email: user.email,
        fcmToken: matchingDevice ? matchingDevice.fcmToken : user.fcmToken,
        hashedDeviceId: matchingDevice ? matchingDevice.hashedDeviceId : "",
        songRequestList: user.songRequestList,
      };
    });
  }, [userList, deviceList]);

  const toggleExpandRow = (index: number) => {
    setExpandedRowIndex(expandedRowIndex === index ? null : index);
  };

  // // hashedDeviceIdist를 이용해 유저 필터링
  const filterUsersByDeviceId = () => {
    const filteredList = deviceList.filter((device) =>
      hashedDeviceIdList.includes(device.hashedDeviceId)
    );

    // console.log(filteredList.length);
    setFilteredDeviceList(filteredList);
    // setFilteredUsers(filteredList);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h1>유저 정보</h1>
        <PushNotificationFormMany
          tokens={filteredDeviceList.map((device) =>
            device.fcmToken ? device.fcmToken : "토큰없음"
          )}
        />
      </div>
      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <input
            type="text"
            placeholder="deviceId1, deviceId2, ..."
            onChange={(e) => {
              setHashedDeviceIdList(
                e.target.value.split(",").map((id) => id.trim())
              );
            }}
            style={{ width: "300px", padding: "5px" }}
          />
          <button onClick={filterUsersByDeviceId}>유저 찾기</button>
        </div>
        <div>
          <h3>필터링된 유저 {filteredDeviceList.length}명</h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            {Array.from({ length: 3 }).map((_, rowIndex) => (
              <div key={rowIndex} style={{ display: "flex", gap: "8px" }}>
                {filteredDeviceList
                  .filter((_, index) => index % 3 === rowIndex)
                  .map((device) => (
                    <div
                      key={device.userId}
                      style={{
                        whiteSpace: "nowrap",
                        border: "1px solid black",
                        padding: "12px",
                      }}
                    >
                      <p>{device.fcmToken.slice(0, 10) || "토큰 없음"}</p>
                      <p>{device.userName || "이름 없음"}</p>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* 페이징 버튼 */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <button onClick={handlePreviousPage} disabled={currentPage === 1}>
          이전
        </button>
        <span style={{ margin: "0 10px" }}>
          {currentPage} / {totalPages}
        </span>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          다음
        </button>
      </div> */}
      {/* 제일 위 표시줄 */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "0.4fr 1fr 1.5fr 1fr 1fr 1fr 3fr",
          borderBottom: "2px solid #000",
          paddingBottom: "10px",
        }}
      >
        <strong></strong>
        <strong>UserId</strong>
        <strong>Email</strong>
        <strong>UserName</strong>
        <strong>FCM Token</strong>
        <strong>HashedDeviceId</strong>
        <strong>Song Requests</strong>
      </div>
      {/* 유저 표 */}
      {mergedUserData.map((user, index) => (
        <div
          key={user.userId + index + user.email}
          style={{
            display: "grid",
            gridTemplateColumns: "0.4fr 1fr 1.5fr 1fr 1fr 1fr 3fr",
            padding: "10px 0",
            borderBottom: "1px solid #ccc",
            alignItems: "center",
          }}
        >
          <span>{(currentPage - 1) * itemsPerPage + index + 1}</span>
          <CopyText
            text={user.userId || ""}
            displayText={user.userId ? user.userId.slice(0, 10) : ""}
          />
          <CopyText
            text={user.email ? user.email : ""}
            displayText={user.email ? user.email : ""}
          />
          <CopyText
            text={user.userName || ""}
            displayText={user.userName ? user.userName.slice(0, 10) : ""}
          />
          <CopyText
            text={user.fcmToken || ""}
            displayText={user.fcmToken ? user.fcmToken.slice(0, 10) : ""}
          />
          <CopyText
            text={user.hashedDeviceId || ""}
            displayText={
              user.hashedDeviceId ? user.hashedDeviceId.slice(0, 10) : ""
            }
          />
          <div>
            <p
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => toggleExpandRow(index)}
            >
              {user.songRequestList.length > 0
                ? `${user.songRequestList[0].artistName}-${user.songRequestList[0].songTitle} (${user.songRequestList.length})`
                : ``}
            </p>
            {expandedRowIndex === index && (
              <div style={{ marginTop: "10px" }}>
                {user.songRequestList.map((songRequest) => (
                  <div
                    style={{ display: "flex", gap: "4px" }}
                    key={songRequest.songRequestId}
                  >
                    <p>{songRequest?.artistName}</p>
                    <p>{songRequest?.songTitle}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default UserDevicePage;
